<template>
    <div
        @mouseout="selectedIngredient = null"
        class="grid grid-cols-1 sm:grid-cols-2 gap-x-8"
    >
        <div class="hidden sm:block mx-auto px-4">
            <div
                v-if="!selectedIngredient"
                class="h-full flex flex-col justify-center"
            >
                <slot name="product" />
            </div>
            <div
                v-else
                class="h-full flex flex-col justify-center text-gray-700 text-center max-w-xs prose lg:prose-lg"
            >
                <slot :name="`ingredient${selectedIngredient}-description`" />
            </div>
        </div>

        <div>
            <div
                :class="[
                    ingredients > 5 ? 'sm:grid-cols-6' : 'sm:grid-cols-4',
                    'sm:max-w-md mx-auto grid grid-cols-1 gap-8 text-center text-gray-700 mt-8 sm:mt-2 px-4 sm:pl-0',
                ]"
            >
                <div
                    @mouseout.stop
                    v-for="ingredientId in ingredients"
                    :key="ingredientId"
                    :class="[
                        (ingredients === 11 &&
                            ingredientId === ingredients - 1) ||
                        (ingredients <= 5 && ingredientId === ingredients)
                            ? 'sm:col-start-2'
                            : '',
                        ingredients === 7 && ingredientId === ingredients
                            ? 'sm:col-start-3'
                            : '',
                        'sm:col-span-2 grid grid-cols-1 gap-8',
                    ]"
                >
                    <div
                        @mouseover="selectedIngredient = ingredientId"
                        :class="[
                            selectedIngredient === ingredientId
                                ? 'transform -translate-y-1 scale-110'
                                : '',
                            'transition duration-500 ease-in-out cursor-pointer',
                        ]"
                    >
                        <slot :name="`ingredient${ingredientId}`" />
                    </div>
                    <div
                        v-if="selectedIngredient === ingredientId"
                        class="sm:hidden text-gray-700 text-center prose"
                    >
                        <slot :name="`ingredient${ingredientId}-description`" />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import { ref } from "vue";

defineProps<{
    ingredients: number;
}>();

const selectedIngredient = ref<number | null>(null);
</script>
